import '../components/vueData/vueData.element';
import '../components/product-family/product-family.element';
import '../components/carousel/carousel';
import '../components/carousel/carousel-container';
import '../components/carousel/carousel-navi-next';
import '../components/carousel/carousel-navi-prev';
import '../components/tooltip/tooltip';
import '../components/scroll-to-top/scroll-to-top';
import '../components/anchor-link/anchor-link.element';
import '../components/modal/modal';
import { initLinks } from '../components/shop-link/shop-link';

initLinks(document.body);
